export class GlimpseConfig {
  public readonly file_name = 'LogoTransparentWhites.png';
  public readonly height = '60px';
  public readonly width = '';

  constructor() {}
}
